import React from 'react';
import { Alert, Box, Chip, LinearProgress, Typography } from '@mui/material';
import { AutoAwesome } from '@mui/icons-material';
import { GenerationJob } from '../../types/api';

interface GenerationJobBannerProps {
  job: GenerationJob;
}

const STATUS_LABEL: Record<string, string> = {
  PENDING: 'Queued',
  STARTED: 'In progress',
  SUCCESS: 'Complete',
  FAILURE: 'Failed',
};

export const GenerationJobBanner: React.FC<GenerationJobBannerProps> = ({ job }) => {
  const label = STATUS_LABEL[job.status] ?? job.status;

  return (
    <Alert
      severity={job.status === 'FAILURE' ? 'error' : 'info'}
      icon={<AutoAwesome />}
      sx={{ mb: 3 }}
    >
      <Box sx={{ width: '100%' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', mb: 1 }}>
          <Typography variant="subtitle2">
            Creating post: <strong>{job.topic}</strong>
          </Typography>
          <Chip label={label} size="small" color={job.status === 'STARTED' ? 'primary' : 'default'} />
          {job.variants > 1 && (
            <Chip label={`${job.variants} variants`} size="small" variant="outlined" />
          )}
        </Box>
        <Typography variant="body2" color="text.secondary">
          {job.message}
        </Typography>
        {job.status !== 'FAILURE' && job.status !== 'SUCCESS' && (
          <LinearProgress sx={{ mt: 1.5, borderRadius: 1 }} />
        )}
      </Box>
    </Alert>
  );
};

export default GenerationJobBanner;
